export class Host {
    // url: string;
    name: string;
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/host.ts